import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Col from 'reactstrap/lib/Col';

import './notification-message.scss';

const TEXT_STATUS_MAP = {
  info: 'text-warning',
  error: 'text-danger',
  success: 'text-success',
};

const TEXT_STATUS_ARIA = {
  info: 'Info',
  error: 'Error',
  success: 'Success',
};

export function NotificationMessage({
  children,
  level = 'error',
  showInContainer = true,
  className = '',
  iconClassNames = 'icon-notification2 h3 me-0_5 d-block mb-0',
  id = undefined,
}) {
  return (
    <Col xs={12} className={classNames({ 'notification-container': showInContainer }, className)} role="alert">
      <span className="d-flex align-items-center small bg-white rounded p-0_25 notification-message mt-0_5">
        <i
          className={classNames(iconClassNames, TEXT_STATUS_MAP[level])}
          role="img"
          aria-label={TEXT_STATUS_ARIA[level]}
        />
        <span id={id}>{children}</span>
      </span>
    </Col>
  );
}

NotificationMessage.propTypes = {
  children: PropTypes.node.isRequired,
  level: PropTypes.oneOf(['info', 'error', 'success']),
  showInContainer: PropTypes.bool,
  className: PropTypes.string,
  iconClassNames: PropTypes.string,
  id: PropTypes.string,
};
